import { render, staticRenderFns } from "./SolicitacaoRespostaFreteListaDetails.vue?vue&type=template&id=6ed27eba"
import script from "./SolicitacaoRespostaFreteListaDetails.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaFreteListaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports